import { GetFlightFaresState } from './getFlightFares.types'

const initialState: GetFlightFaresState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
